import { render, staticRenderFns } from "./she100.vue?vue&type=template&id=20a69ea4&scoped=true"
import script from "./she100.vue?vue&type=script&lang=ts"
export * from "./she100.vue?vue&type=script&lang=ts"
import style0 from "./she100.vue?vue&type=style&index=0&id=20a69ea4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a69ea4",
  null
  
)

export default component.exports